import _throwOnMissingKey from 'rlink-collections/_throwOnMissingKey';

export default function getAt (obj, path = [], coveredPath = [], onMissingKey = _throwOnMissingKey) {
  if (path.length === 0) {
    return obj;
  }
  let [nextKey, ...remainingPath] = path;
  if (this.isCollection(obj) && this.hasKey(obj, nextKey)) {
    return this.getAt(
      this.valueForKey(obj, nextKey),
      remainingPath,
      coveredPath.concat([nextKey]),
      onMissingKey
    );
  } else {
    return onMissingKey(obj, coveredPath, nextKey, remainingPath);
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/getAt.js